function getPackageHasLoyaltyUpgrade(pkg: App.HotelPackage): boolean {
  return !!(pkg.loyalty.upgradeTargets?.room || pkg.loyalty.upgradeTargets?.package)
}

export default getPackageHasLoyaltyUpgrade
